// extracted by mini-css-extract-plugin
export default {"paragraph":"view-more_paragraph__ZT523","showMore":"view-more_showMore__FZNDc","chevron":"view-more_chevron__NczK4"};